import { render, staticRenderFns } from "./water-export-edit.vue?vue&type=template&id=5f8def74&"
import script from "./water-export-edit.vue?vue&type=script&lang=ts&"
export * from "./water-export-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports